
import { Avatar, Box, IconButton, Menu, MenuItem, Stack, Typography, Badge, Divider, ListItemIcon, ListItemText, Collapse } from '@mui/material';
import { NotificationsNone } from '@mui/icons-material';
import { HEADER } from '../config-layout';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import logoutController from '../controllers/logout.controller';
import checkAuthController from '../controllers/check-auth.controller';
import { UserInfoModel } from '../../../pages/user/models/user.model';
import NotificationListController from '../../../pages/notificationList/controllers/notificationlist.controller';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import MobileDrawer from './MobileDrawer';
import useScreenWidth from '../../../hooks/use-page-width';
import ChangePasswordModal from '../../../components/changePassword/ChangePassword';
const Header = () => {
  const notList = NotificationListController();
  const logoutCtrl = logoutController();
  const checkUser = checkAuthController();
  const navigate = useNavigate();
  const width = useScreenWidth();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const countUnread = () => {
    const listUnread = notList.listNotification?.filter(e => e.is_read === false).length;
    return listUnread;
  }

  useEffect(() => {
    checkUser.getLoginUser();
  }, []);

  const user: UserInfoModel | null = checkUser.loginUser;

  return (
    <Box
      sx={{
        height: HEADER.H_DESKTOP,
        backgroundColor: 'transparent',
        px: width > 600 ? 4 : 1,
        color: '#EEEFF3',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          justifyContent: "space-between",
          alignItems: 'center',
        }}
      >
        <Box sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}>
          <Collapse unmountOnExit={true} orientation={"horizontal"} in={width < 600 && width != 0 ? true : false}>
            <MobileDrawer />
          </Collapse>
          <Typography>{user?.role_id?.role_name ?? ""}</Typography>
        </Box>
        <Box />


        <Stack direction="row" alignItems="center" spacing={1}>
          <div>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
            >
              <Avatar sx={{ width: 32, height: 32 }} />
            </IconButton>

            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <Box flex={1} display={"flex"} flexDirection={"row"} alignItems={"center"} paddingLeft={"10px"} paddingRight={"20px"} paddingTop={"5px"} paddingBottom={"10px"}>
                <PersonIcon sx={{ color: "gray" }} />
                <Box width={"5px"} />
                <Typography>{user !== null ? user["first_name"] + " " + user["last_name"] : ""}</Typography>
              </Box>
              <Divider />
              <ChangePasswordModal onCloseMenuProfile={handleClose} />
              <MenuItem onClick={logoutCtrl.logout}>
                <ListItemText sx={{ paddingRight: "20px" }}>ອອກຈາກລະບົບ</ListItemText>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
              </MenuItem>
            </Menu>
          </div>

          <IconButton onClick={() => navigate('/notification-list')}>
            <Badge badgeContent={countUnread()} color="error">
              <NotificationsNone sx={{ color: '#EEEFF3', fontSize: 30 }} />
            </Badge>
          </IconButton>
        </Stack>
      </Box>
    </Box>
  );
};

export default Header;
